import { cva, type VariantProps } from 'class-variance-authority'

export const pillVariants = cva(
  'inline-flex items-center font-sans text-sm font-medium rounded-full px-4 py-1.5 cursor-pointer transition-colors',
  {
    variants: {
      state: {
        active: 'bg-ink text-bg',
        inactive: 'bg-surface text-ink-3 border border-line hover:bg-surface-2',
      },
    },
    defaultVariants: {
      state: 'inactive',
    },
  },
)

export type PillVariantProps = VariantProps<typeof pillVariants>
